import React, { useState } from "react";

const SpaceThumbnail = ({ space, selectedSpace, setSelectedSpace }) => {
  const [spacePhoto] = useState(space.getPhoto());
  return (
    <div
      className={`space-thumbnail ${
        selectedSpace?._subjects?._value?._id === space._subjects._value._id
          ? "isSelected"
          : ""
      }`}
      onClick={() => setSelectedSpace(space)}
    >
      <div className="space-thumbnail__image">
        <img
          src={
            spacePhoto
              ? spacePhoto
              : "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/image_placeholder.png"
          }
          alt={space?._subjects?._value?.name || "Placeholder image"}
        />
        {selectedSpace?._subjects?._value?._id ===
          space._subjects._value._id && (
          <span className="space-thumbnail__selected" />
        )}
      </div>
      <h4 className="space-thumbnail__title">{space._subjects._value.name}</h4>
    </div>
  );
};

export default SpaceThumbnail;
